import React from "react"
import { useGlobalStateStore } from "@/store/GlobalState"

import NewSideBar from "@/@integrations/Whatsapp/components/Menu/NewSideBar"
import { isSmallScreen } from "@/utils/checkDevice"
import MobileMenuBar from "@/@integrations/Whatsapp/components/Menu/MobileMenuBar"

type MenuProps = {
	hiddenTabs: boolean
	openDrawer: boolean
	onClose: () => void
}

const Menu = (props: MenuProps) => {
	const {
		openDrawer,
		onClose
	} = props

	const globalStateStore = useGlobalStateStore()
	const channelType = globalStateStore.instance.current_channel_type

	const hasPermissionToSeeAIAgentsOption = Boolean(globalStateStore.instance.subscriptionData?.limits?.permission?.agent)
	if (isSmallScreen) {
		return <MobileMenuBar menuType={channelType}/>
	}

	return (
		<NewSideBar
			onClose={onClose}
			openDrawer={openDrawer}
			hiddenTabs={hasPermissionToSeeAIAgentsOption}
			channelType={channelType}
		/>
	)
}

export default Menu
